export const textConstants = {
  warning: {
    uploadWhileUploading: {
      title: "Hang tight!",
      description:
        "Your current images are still being uploaded. Once they're all set, you'll be free to upload more.",
    },
  },
} as const
